<template>
  <div class="faultReason">
    <div class="reasonInput">
      <van-field
        v-model="fault"
        placeholder="请输入故障原因"
        left-icon="search"
        @input="queryParams"
      />
    </div>
    <div class="goodTitle">
      <div
        class="reason"
        v-for="(item, index) in faultReasonDataList"
        :key="index"
      >
        <van-cell is-link @click="showPopup(item)">{{
          item.faultCause
        }}</van-cell>
      </div>
      <van-popup
        v-model="show"
        position="bottom"
        :style="{ height: '80%' }"
        closeable
      >
        <div class="faultContent">
          <h5 class="faultTitle">{{ faultTitle }}</h5>
          <div class="reasonCheck">
            <div class="swiper">
              <van-swipe
                class="my-swipe"
                indicator-color="#717171"
                ref="vanSwiper"
              >
                <van-swipe-item
                  v-for="(i, index) in faultReasonInfo"
                  :key="index"
                >
                  <h6 class="reasonTitle">可能原因</h6>
                  <div class="reasonContent">{{ i.possibleCause }}</div>
                  <h6 class="reasonTitle">故障排除建议</h6>
                  <div class="exclusionAdvice">
                    {{ i.exclusionAdvice }}
                  </div>
                </van-swipe-item>
              </van-swipe>

              <div class="toggle" v-if="faultReasonInfo.length > 1">
                <span class="prve"
                  ><van-icon name="arrow-left" @click="prev"
                /></span>
                <span class="next" @click="next"
                  ><van-icon name="arrow"
                /></span>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="consult">
      <div>
        如仍有疑问，仍无法解决，点击咨询
        <span @click="service" style="color: #2485e6">人工客服</span>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "faultReason",
  data() {
    return {
      fault: "",
      show: false,
      faultReasonDataList: [],
      faultReasonInfo: [],
      faultTitle: ""
    };
  },
  mounted() {
    this.getFaultReason();
  },
  methods: {
    // 获取故障原因
    getFaultReason() {
      const json = {
        productId: this.$route.query.id
      };
      apis.faultReasonList(json).then(res => {
        if (res.code === 200) {
          this.faultReasonDataList = res.data;
        }
      });
    },
    // 搜索
    queryParams(value) {
      const json = {
        productId: this.$route.query.id,
        faultCause: value
      };
      apis.faultReasonList(json).then(res => {
        if (res.code === 200) {
          this.faultReasonDataList = res.data;
        }
      });
    },
    // 弹窗
    showPopup(item) {
      this.faultTitle = item.faultCause;
      apis.faultReasonData({ faultCauseId: item.id }).then(res => {
        if (res.code === 200) {
          this.faultReasonInfo = res.data;
        }
      });
      this.show = true;
    },
    // 上下切换
    prev() {
      this.$refs.vanSwiper.prev();
    },
    // 上下切换
    next() {
      this.$refs.vanSwiper.next();
    },
    // 人工客服
    service() {
      // window.open("https://work.weixin.qq.com/kfid/kfc8970885ac4a02586");
      window.open("https://work.weixin.qq.com/kfid/kfcfce44ed386dd434f");
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .faultReason {
    width: 100%;
  }
  ::v-deep .van-popup {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .faultReason {
    width: 276px * $zoom;
  }
  ::v-deep .van-popup {
    width: 276px * $zoom;
  }
}
.faultReason {
  font-size: 16px * $zoom;
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  .reasonInput {
    height: 126px;
    ::v-deep .van-field {
      width: 94%;
      background-color: #f7f9fa;
      border-radius: 30px;
      margin-left: 3.4%;
      margin: 30px 0 30px 3.4%;
      &::after {
        content: "";
        width: 0;
        height: 0;
      }
    }
  }

  .goodTitle {
    flex: 1;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .title {
      width: 100%;
      height: 72px;
      background-color: white;
      text-align: center;
      font-size: 33px;
    }
    .reason {
      border-bottom: 1px solid #dcdcdc;
    }
    ::v-deep .van-popup {
      left: initial;
      .faultContent {
        .faultTitle {
          margin-top: 10px;
          height: 73px;
          line-height: 73px;
          text-align: center;
          font-size: 33px;
          border-bottom: 1px solid #e5e5e5;
          font-weight: bold;
          color: #282b32;
        }
        .reasonCheck {
          padding: 0 20px;

          .swiper {
            position: relative;
            width: 100%;

            .van-swipe-item {
              font-size: 25px;
              overflow-y: auto;
              text-indent: 2em;
              &::-webkit-scrollbar {
                display: none;
              }
              .reasonTitle {
                height: 73px;
                line-height: 73px;
                font-size: 30px;
                color: #7e817e;
                margin-bottom: 30px;
                margin-left: -26px;
              }
              .reasonContent {
                font-size: 25px;
                margin-bottom: 70px;
              }
              .exclusionAdvice {
                height: 350px;
                overflow-y: auto;
                &::-webkit-scrollbar {
                  display: none;
                }
              }
            }
            .van-swipe__indicator {
              border-radius: 10px;
              background-color: #c2c2c2;
            }
            @media screen and (max-width: 600px) {
              .toggle {
                width: 95%;
              }
            }
            @media screen and (min-width: 600px) {
              .toggle {
                width: 250px * $zoom;
              }
            }
            .toggle {
              position: absolute;
              bottom: -63px;
              left: 0;
              right: 0;
              margin: 0 auto;
              display: flex;
              justify-content: space-between;

              .van-icon {
                color: rgb(99, 96, 96);
              }
            }
          }
        }
      }
    }
    ::v-deep .van-overlay {
      background-color: rgba(147, 144, 144, 0.6);
    }
    ::v-deep .van-popup__close-icon {
      height: 50px;
      width: 50px;
    }
    ::v-deep .van-popup__close-icon--top-right {
      top: 90%;
      right: 45%;
    }
    ::v-deep .van-icon-cross:before {
      content: "";
      background-image: url("~@/assets/gzh/bottomArrows2.png");
      background-size: cover;
      width: 50px;
      height: 15px;
    }
  }
  .consult {
    height: 60px;
    line-height: 60px;
    font-size: 22px;
    color: #848485;
    div {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
